import { Switch as MuiSwitch, type SwitchProps as MuiSwitchProps } from "@mui/material";

export type SwitchProps = MuiSwitchProps;
export const Switch = MuiSwitch;
